/** Snapshot of the video settings a batch card can override. Defaults match the workspace/device. */
export function emptyBatchVideoSettingsFrom(source) {
    const s = source || {};
    return {
        fastPacing: !!s.fastPacing,
        speedUp: !!s.speedUp,
        flipbookIntro: !!s.flipbookIntro,
        openingLineInCenter: !!s.openingLineInCenter,
        openingLineTextSize: s.openingLineTextSize === 'small' ? 'small' : 'big',
        openingLineFontId: s.openingLineFontId || '',
        openingLineFontColor: s.openingLineFontColor || '#ffffff',
        fontMixing: !!s.fontMixing,
        centerStackOpening: !!s.centerStackOpening,
        centerStackLineByLine: !!s.centerStackLineByLine,
        fontMixingSecondColor: s.fontMixingSecondColor || '#F5D66D',
        boukisIntro: !!s.boukisIntro,
        boukisIntroPitch: s.boukisIntroPitch === 'low' ? 'low' : 'high',
        enableSubtitles: s.enableSubtitles !== false,
        selectedFontId: s.selectedFontId || '',
        subtitleFontColor: s.subtitleFontColor || '#ffffff',
        subtitleOutlineEnabled: !!s.subtitleOutlineEnabled,
        subtitleOutlineColor: s.subtitleOutlineColor || '#000000',
        bigText: !!s.bigText,
        subtitlePosition: s.subtitlePosition === 'center' ? 'center' : 'bottom',
        oneWordPerSubtitle: !!s.oneWordPerSubtitle,
        glowText: !!s.glowText,
        glowTextColor: s.glowTextColor === 'black' ? 'black' : 'white',
        cutSilenceMode: !!s.cutSilenceMode,
        cutMoreSilenceMode: !!s.cutMoreSilenceMode,
        aiSoundEffects: !!s.aiSoundEffects,
        useMusic: s.useMusic !== false,
    };
}

/** Timeline export fields win over the per-video (or workspace) snapshot. */
export function mergeBatchVideoSettingsWithExport(base, extras) {
    const next = { ...(base || {}) };
    if (!extras) return next;
    const assignBool = (extraKey, settingsKey = extraKey) => {
        if (extras[extraKey] !== undefined) next[settingsKey] = !!extras[extraKey];
    };
    assignBool('flipbookIntro');
    assignBool('cutSilenceMode');
    assignBool('fastPacing');
    assignBool('enableSubtitles');
    assignBool('oneWordPerSubtitle');
    assignBool('bigText');
    assignBool('glowText');
    assignBool('subtitleOutlineEnabled');
    assignBool('openingLineInCenter');
    assignBool('fontMixing');
    assignBool('centerStackOpening');
    assignBool('centerStackLineByLine');
    if (extras.subtitlePosition) next.subtitlePosition = extras.subtitlePosition;
    if (extras.openingLineTextSize) next.openingLineTextSize = extras.openingLineTextSize;
    if (Object.prototype.hasOwnProperty.call(extras, 'fontId')) next.selectedFontId = extras.fontId || '';
    if (extras.subtitleFontColor) next.subtitleFontColor = extras.subtitleFontColor;
    if (extras.subtitleOutlineColor) next.subtitleOutlineColor = extras.subtitleOutlineColor;
    if (Object.prototype.hasOwnProperty.call(extras, 'openingLineFontId')) next.openingLineFontId = extras.openingLineFontId || '';
    if (extras.openingLineFontColor) next.openingLineFontColor = extras.openingLineFontColor;
    if (extras.fontMixingSecondColor) next.fontMixingSecondColor = extras.fontMixingSecondColor;
    if (extras.glowTextColor === 'black' || extras.glowTextColor === 'white') next.glowTextColor = extras.glowTextColor;
    if (Object.prototype.hasOwnProperty.call(extras, 'selectedMusicId')) next.useMusic = !!extras.selectedMusicId;
    return next;
}

export function resolveBatchVideoSettings({ perVideo, globals, extras }) {
    const base = perVideo
        ? emptyBatchVideoSettingsFrom(perVideo)
        : emptyBatchVideoSettingsFrom(globals);
    return mergeBatchVideoSettingsWithExport(base, extras);
}

export function openingLineFontFields(settings, fonts, isBoukar) {
    if (!isBoukar || !settings) return {};
    if (!settings.openingLineInCenter && !settings.fontMixing && !settings.centerStackOpening && !settings.centerStackLineByLine) return {};
    const fontId = settings.openingLineFontId
        || ((settings.fontMixing || settings.centerStackOpening || settings.centerStackLineByLine) ? settings.selectedFontId : '');
    if (!fontId) return {};
    const font = (fonts || []).find((f) => String(f._id) === String(fontId));
    return {
        openingLineFontId: fontId,
        openingLineCustomFontUrl: font?.url || undefined,
    };
}

export function rekeyByScriptId(map, oldId, newId) {
    if (!map || map[oldId] == null || String(oldId) === String(newId)) return map;
    const next = { ...map, [newId]: map[oldId] };
    delete next[oldId];
    return next;
}
